import { render, staticRenderFns } from "./sc-table-button-confirm.vue?vue&type=template&id=9ba47ef8&scoped=true&"
import script from "./sc-table-button-confirm.vue?vue&type=script&lang=js&"
export * from "./sc-table-button-confirm.vue?vue&type=script&lang=js&"
import style0 from "./sc-table-button-confirm.vue?vue&type=style&index=0&id=9ba47ef8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba47ef8",
  null
  
)

export default component.exports